
<template>
  <div>
    <template v-if="item_can_use_conditional_email">
      <v-subheader>Enviar email com condicional de resposta?</v-subheader>
      <v-sheet class="ml-2 mb-4" max-width="1000" >
        <v-slide-group mandatory v-model="newItem.send_email_depending_on_answer" center-active>
          <v-slide-item :value="kind.kind" v-for="(kind,idx) in all_kind_email_conditional" :key="'ckind5'+idx" v-slot:default="{ active, toggle }">
            <v-btn class="mr-1" depressed rounded :input-value="active" @click="toggle" 
              active-class="secondary darken-1 white--text"
            >
              <v-icon left>{{kind.icon}}</v-icon>{{kind.name}}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>

      <template v-if="newItem.send_email_depending_on_answer">
        <v-subheader>Notificar sobre esse item quando:</v-subheader>
        <v-sheet class="ml-2" max-width="1000" >
          <v-slide-group mandatory v-model="newItem.send_email_when_answer_is" center-active>
            <v-slide-item :value="kind.kind" v-for="(kind,idx) in conditions" :key="'ckind5'+idx" v-slot:default="{ active, toggle }">
              <v-btn class="mr-1" depressed rounded :input-value="active" @click="toggle" 
                active-class="secondary darken-1 white--text"
              >
                <v-icon left>{{kind.icon}}</v-icon>{{kind.name}}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </template>





    </template>


  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ItemEmailNotificationSetup',
  data() {
    return {
      newItem: this.$attrs.newItem,
      all_kind_email_conditional: [
        {name: 'Não', kind: false, icon:'mdi-close'},
        // {name: 'Apenas para inconformidades', kind: '1', icon:'mdi-check'},
        {name: 'Sim', kind: true, icon:'mdi-check-all'},
      ],

      conditions: [
        {name: 'houver inconformidades',      kind: 'failed', icon:'mdi-close'},
        {name: 'a resposta estiver conforme', kind: 'succeeded', icon:'mdi-check-all'},
      ]
    }                       
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    item_can_use_conditional_email() {
      let can_use = true
      const available_kinds = [
        'thumb',
        'react',
        'rating',
        'input',
        'options'
      ]
      can_use = available_kinds.includes(this.newItem.kind.toLowerCase())
      if (can_use){
        if (this.newItem.kind == 'input'){
          can_use = this.newItem.input_kind == 'number' // era para ser number, e nao true
        } else if (this.newItem.kind == 'options'){
          can_use = this.newItem.sub_items.some(si => si.is_minimum)
        }
      }

      return can_use
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>